const TiposStatusPedido = {
   Pendente: 1,
   PagamentoIdentifica: 2,
   EmTransporte: 3,
   Concluido: 4,
   Cancelado: 5,
}

export default TiposStatusPedido;